// ─── Ask Kory prompt sets (per dashboard) ───────────────────────────────────
// The questions the Ask Kory widget cycles through. Keep them short — they
// render as pills. Mobile shows one at a time; desktop shows three at once,
// both rotating through the full list. The Kory tray's starters are the head of each set.
export const DEFAULT_KORY_PROMPTS = [
  "What should I focus on today?",
  "Catch me up on yesterday",
  "Any company news?",
  "What's on my plate this week?",
  "What needs my attention?",
  "How are my brands doing?",
  "What changed since I last logged in?",
  "Any wins worth celebrating?",
  "Summarize my unread updates",
  "Draft an update for my team",
];

export const SALES_KORY_PROMPTS = [
  "What should I focus on today?",
  "Which deals need a nudge?",
  "How's my pipeline looking?",
  "What did I close this week?",
  "Who haven't I followed up with?",
  "Which leads are going cold?",
  "Catch me up on my accounts",
  "What's my biggest opportunity right now?",
  "Any deals at risk of slipping?",
  "Draft a follow-up for my top deal",
];

/** How many prompts the tray offers before your first turn: the head of the dashboard's set. */
const STARTER_COUNT = 3;

/** The tray's starter prompts from a dashboard's prompt set (the default set without one). */
export function starterPrompts(prompts?: readonly string[]): string[] {
  return (prompts?.length ? prompts : DEFAULT_KORY_PROMPTS).slice(0, STARTER_COUNT);
}

/** The prompt set for a role's dashboard: sales has its own; everyone else the default. */
export function rolePrompts(role?: string): readonly string[] {
  return role === "sales" ? SALES_KORY_PROMPTS : DEFAULT_KORY_PROMPTS;
}
